import React from "react"
import Text from "@amzn/meridian/text";
import {FormattedMessage} from "react-intl";
import Column from "@amzn/meridian/column";
import Link from "@amzn/meridian/link";
import {useDeviceLayout} from "../common/context/DeviceLayoutContext";

const ActionableMetricPairView = (props) => {
    const {textFont} = useDeviceLayout()

    const onFirstMetricClick = () => {
        if (props.data.onClickFirst) {
            props.data.onClickFirst();
        }
    }

    const onSecondMetricClick = () => {
        if (props.data.onClickSecond) {
            props.data.onClickSecond();
        }
    }

    return (
        <Column spacing={"small"}>
            <Text type="d50">
                <Link type={"secondary"} onClick={onFirstMetricClick}>{props.data.firstValue}</Link>/
                <Link type={"secondary"} onClick={onSecondMetricClick}>{props.data.secondValue}</Link>
            </Text>
            <Text type={textFont} color={"secondary"} >
                <FormattedMessage id={props.data.footerId} defaultMessage={props.data.defaultFooter} />
            </Text>
        </Column>
    )
}

export default ActionableMetricPairView


// WEBPACK FOOTER //
// ./src/components/pickStatus/ActionableMetricPairView.js